import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import SidebarSection from "./SidebarSection";
import {
    AppShell,
    SidebarContainer,
    SidebarScroll,
    SidebarTitle,
    ContentArea,
    SidebarOption,
    ThinHr,
} from "./ui/StyledUI";
import { getPersonalizationItems, getRoomById } from "../../../../api/RoomsController";
import * as constants from "../../../../constants";
import { socket } from "../../../../socket";
import OverviewContent from "./OverviewContent";
import MediaFrames from "./MediaFrames";
import Interactions from "./Interactions";
import Guestbook from "./Guestbook";
import PreviewImg from "../../../../assets/images/mediaPreview/Web_Graphic_MyRoom_IntraportPreview.png";
import WebGraphicMyRoomPlaceholderSquare from "../../../../assets/images/mediaPreview/Web_Graphic_MyRoom_Placeholder_Square.png";
import WebGraphicMyRoomPlaceholderVertical from "../../../../assets/images/mediaPreview/Web_Graphic_MyRoom_Placeholder_Vertical.png";
import WebGraphicMyRoomPlaceholderVideo from "../../../../assets/images/mediaPreview/Web_Graphic_MyRoom_Placeholder_Video.png";
import LoadingIcon from "../../../../components/common/loading/LoadingIcon";

import Img1 from "../../../../assets/images/interactions/country/american_flag_pallet.jpg";
import Img2 from "../../../../assets/images/interactions/country/dart_board.jpg";
import Img3 from "../../../../assets/images/interactions/country/drums.jpg";
import Img4 from "../../../../assets/images/interactions/country/guitar_rack.jpg";
import Img5 from "../../../../assets/images/interactions/country/playlist_asset.jpg";
import Img6 from "../../../../assets/images/interactions/country/pool_table.jpg";
import Img7 from "../../../../assets/images/interactions/country/table.jpg";
import Img8 from "../../../../assets/images/interactions/country/woodbox.jpg";

import RBImg1 from "../../../../assets/images/interactions/r&b/1_1_frame_2.003.jpg";
import RBImg2 from "../../../../assets/images/interactions/r&b/center_table_1_v2.jpg";
import RBImg3 from "../../../../assets/images/interactions/r&b/image_baseroom_rnb_frame6_9-16.jpg";
import RBImg4 from "../../../../assets/images/interactions/r&b/stereo.002.jpg";
import RBImg5 from "../../../../assets/images/interactions/r&b/stereo.004.jpg";
import RBImg6 from "../../../../assets/images/interactions/r&b/table_top.002.jpg";
import RBImg7 from "../../../../assets/images/interactions/r&b/vinyl_player.001.jpg";
import RBImg8 from "../../../../assets/images/interactions/r&b/vinyl_player.jpg";

import PopImg1 from "../../../../assets/images/interactions/pop/bar_cart_001.jpg";
import PopImg2 from "../../../../assets/images/interactions/pop/guitar_amp_6.jpg";
import PopImg3 from "../../../../assets/images/interactions/pop/metalic_table.005.jpg";
import PopImg4 from "../../../../assets/images/interactions/pop/playlist_asset_1.jpg";
import PopImg5 from "../../../../assets/images/interactions/pop/playlist_asset_2.jpg";
import PopImg6 from "../../../../assets/images/interactions/pop/vinyl_half.002.jpg";
import PopImg7 from "../../../../assets/images/interactions/pop/vinyl_half.003.jpg";
import PopImg8 from "../../../../assets/images/interactions/pop/vinyl_player.jpg";

import RockImg1 from "../../../../assets/images/interactions/rock/crtv.jpg";
import RockImg2 from "../../../../assets/images/interactions/rock/drums.jpg";
import RockImg3 from "../../../../assets/images/interactions/rock/entrance_shelves.jpg";
import RockImg4 from "../../../../assets/images/interactions/rock/guitar_rack.jpg";
import RockImg5 from "../../../../assets/images/interactions/rock/laptop.jpg";
import RockImg6 from "../../../../assets/images/interactions/rock/studio_table.jpg";
import RockImg7 from "../../../../assets/images/interactions/rock/vinyl_player.jpg";
import RockImg8 from "../../../../assets/images/interactions/rock/vinyl_store_shelf.004.jpg";

import HipHopImg1 from "../../../../assets/images/interactions/hiphop/coffee_table_034.jpg";
import HipHopImg2 from "../../../../assets/images/interactions/hiphop/drum_seat.jpg";
import HipHopImg3 from "../../../../assets/images/interactions/hiphop/graffiti_table_1.jpg";
import HipHopImg4 from "../../../../assets/images/interactions/hiphop/headphones_with_stand_001.001.jpg";
import HipHopImg5 from "../../../../assets/images/interactions/hiphop/headphones_with_stand_001.004.jpg";
import HipHopImg6 from "../../../../assets/images/interactions/hiphop/playlist_asset.jpg";
import HipHopImg7 from "../../../../assets/images/interactions/hiphop/studio_computer_setup.jpg";
import HipHopImg8 from "../../../../assets/images/interactions/hiphop/vinyl_shelf.jpg";

import CustomImg1 from "../../../../assets/images/interactions/custom/guitar_amp_6.jpg";
import CustomImg2 from "../../../../assets/images/interactions/custom/headphones_on_wire.jpg";
import CustomImg3 from "../../../../assets/images/interactions/custom/headphones_with_base_2.jpg";
import CustomImg4 from "../../../../assets/images/interactions/custom/nook_1_v1_2.jpg";
import CustomImg5 from "../../../../assets/images/interactions/custom/retro_storage_cabinet_001.jpg";
import CustomImg6 from "../../../../assets/images/interactions/custom/smalltable_2_v1.jpg";
import CustomImg7 from "../../../../assets/images/interactions/custom/synthesizer.jpg";
import CustomImg8 from "../../../../assets/images/interactions/custom/Vinyl_store_shelf_2.jpg";

import EDMImg1 from "../../../../assets/images/interactions/edm/bebeheadphone.009.jpg";
import EDMImg2 from "../../../../assets/images/interactions/edm/bebeheadphone.011.jpg";
import EDMImg3 from "../../../../assets/images/interactions/edm/coffee_table_021_marble_v1.001.jpg";
import EDMImg4 from "../../../../assets/images/interactions/edm/coffee_table_021_marble_v1.002.jpg";
import EDMImg5 from "../../../../assets/images/interactions/edm/headphones_with_base_001.jpg";
import EDMImg6 from "../../../../assets/images/interactions/edm/stereo.004.jpg";
import EDMImg7 from "../../../../assets/images/interactions/edm/synthesizer.jpg";
import EDMImg8 from "../../../../assets/images/interactions/edm/vinyl_player.jpg";

const DEFAULTS = {
    previewImg: { id: null, url: PreviewImg },
    squareImg: { id: null, url: WebGraphicMyRoomPlaceholderSquare },
    verticalImg1: { id: null, url: WebGraphicMyRoomPlaceholderVertical },
    verticalImg2: { id: null, url: WebGraphicMyRoomPlaceholderVertical },
    videoFrameImg: { id: null, url: WebGraphicMyRoomPlaceholderVideo },
};

export default function SidebarConsole() {
    const user = useSelector((state) => state.user);
    const { roomId, userId } = useParams();
    const [mediaOpen, setMediaOpen] = useState(true);
    const [interOpen, setInterOpen] = useState(true);
    const [guestOpen, setGuestOpen] = useState(true);
    const [selectedSection, setSelectedSection] = useState("Overview");
    const [selectedOption, setSelectedOption] = useState(null);
    const [imagesAndVideosUrls, setImagesAndVideosUrls] = useState(DEFAULTS);
    const [interactionItems, setInteractionItems] = useState([]);
    const [roomType, setRoomType] = useState("pop");
    const [isSocketRequest, setIsSocketRequest] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchRoomPersonalizationItem();
    }, [roomId]);

    const fetchRoomPersonalizationItem = async () => {
        const response = await getPersonalizationItems(roomId);

        if (response.status !== 200) return;
        const data = response.data;
        const items = data.room_personalization_items;
        const MAP = {
            "video_baseroom_frame4_9-16": "videoFrameImg",
            "image_baseroom_frame3_1-1": "squareImg",
            "image_baseroom_frame1_16-9": "verticalImg1",
            "image_baseroom_frame2_16-9": "verticalImg2",
            image_baseroom_intraport_preview: "previewImg",
        };
        const updated = { ...DEFAULTS };
        if (data.roomMainImageFileUrl) {
            updated.previewImg = { id: null, url: data.roomMainImageFileUrl };
        }
        items.forEach((item) => {
            const key = MAP[item.name];
            if (key) {
                updated[key] = {
                    id: item.id,
                    url: item.fileUrl || DEFAULTS[key].url, // fallback to default if fileUrl is null
                };
            }
        });
        setImagesAndVideosUrls(updated);
        const getRoomType = await getRoomById(roomId);
        const tagsNames = getRoomType?.tagsNames || [];

        let roomType = "";

        if (tagsNames.length === 0) {
            roomType = "pop";
            return;
        }

        roomType = tagsNames[0].value;
        roomType = roomType.toLowerCase();
        setRoomType(roomType);

        if (roomType === "country") {
            const countryItems = [
                { name: "American Flag Pallet", img: Img1 },
                { name: "Dart Board", img: Img2 },
                { name: "Drums", img: Img3 },
                { name: "Guitar Rack", img: Img4 },
                { name: "Playlist", img: Img5 },
                { name: "Pool Table", img: Img6 },
                { name: "Table", img: Img7 },
                { name: "Wood Box", img: Img8 },
            ];

            setInteractionItems(countryItems);
        }
        if (roomType === "pop") {
            const countryItems = [
                { name: "Frame 1", img: PopImg1 },
                { name: "Center Table", img: PopImg2 },
                { name: "Baseroom", img: PopImg3 },
                { name: "Stereo 1", img: PopImg4 },
                { name: "Stereo 2", img: PopImg5 },
                { name: "Table Top", img: PopImg6 },
                { name: "Vinyl Player", img: PopImg7 },
                { name: "Vinyl Player 1", img: PopImg8 },
            ];

            setInteractionItems(countryItems);
        }
        if (roomType === "r&b") {
            const countryItems = [
                { name: "Frame 2", img: RBImg1 },
                { name: "Center Table", img: RBImg2 },
                { name: "Baseroom Frame", img: RBImg3 },
                { name: "Stereo 1", img: RBImg4 },
                { name: "Stereo 2", img: RBImg5 },
                { name: "Table Top", img: RBImg6 },
                { name: "Vinyl Player", img: RBImg7 },
                { name: "Vinyl Player 1", img: RBImg8 },
            ];

            setInteractionItems(countryItems);
        }

        if (roomType === "rock") {
            const countryItems = [
                { name: "CRTV", img: RockImg1 },
                { name: "Drums", img: RockImg2 },
                { name: "Entrance Shelves", img: RockImg3 },
                { name: "Guitar Rack", img: RockImg4 },
                { name: "Laptop", img: RockImg5 },
                { name: "Studio Table", img: RockImg6 },
                { name: "Vinyl Player", img: RockImg7 },
                { name: "Vinyl Store Shelf", img: RockImg8 },
            ];

            setInteractionItems(countryItems);
        }

        if (roomType === "hip hop") {
            const countryItems = [
                { name: "Coffee Table", img: HipHopImg1 },
                { name: "Drum Seat", img: HipHopImg2 },
                { name: "Graffiti Table", img: HipHopImg3 },
                { name: "Headphones with Stand 1", img: HipHopImg4 },
                { name: "Headphones with Stand 2", img: HipHopImg5 },
                { name: "Playlist Asset", img: HipHopImg6 },
                { name: "Studio Computer Setup", img: HipHopImg7 },
                { name: "Vinyl Shelf", img: HipHopImg8 },
            ];

            setInteractionItems(countryItems);
        }

        if (roomType === "custom") {
            const countryItems = [
                { name: "Guitar Amp", img: CustomImg1 },
                { name: "Headphones on Wire", img: CustomImg2 },
                { name: "Headphones with Base", img: CustomImg3 },
                { name: "Nook", img: CustomImg4 },
                { name: "Retro Storage Cabinet", img: CustomImg5 },
                { name: "Small Table", img: CustomImg6 },
                { name: "Synthesizer", img: CustomImg7 },
                { name: "Vinyl Store Shelf", img: CustomImg8 },
            ];

            setInteractionItems(countryItems);
        }

        if (roomType === "edm") {
            const countryItems = [
                { name: "Bebe Headphone 1", img: EDMImg1 },
                { name: "Bebe Headphone 2", img: EDMImg2 },
                { name: "Coffee Table Marble 1", img: EDMImg3 },
                { name: "Coffee Table Marble 2", img: EDMImg4 },
                { name: "Headphones with Base", img: EDMImg5 },
                { name: "Stereo", img: EDMImg6 },
                { name: "Synthesizer", img: EDMImg7 },
                { name: "Vinyl Player", img: EDMImg8 },
            ];

            setInteractionItems(countryItems);
        }
        setLoading(false);
    };

    useEffect(() => {
        socket.on("connect", () => console.log("Connected to server:", socket.id));

        socket.on("system_message", (response) => {
            (async () => {
                try {
                    if (typeof response !== "string") return;

                    const isMatch = (constant) => response.includes(constant);
                    const safeParse = () => {
                        try {
                            return JSON.parse(response);
                        } catch {
                            return null;
                        }
                    };
                    if (isMatch(constants.OPEN_IMAGE_UPLOADER)) {
                        const parsed = safeParse();

                        const receivedRoomId = parsed?.[1];
                        const receivedUser = parsed?.[2];
                        const receivedSelectedOption = parsed?.[3];

                        if (receivedRoomId === roomId && receivedUser === userId) {
                            setIsSocketRequest(true);
                            setSelectedSection("Media Frames");
                            setSelectedOption(receivedSelectedOption);
                        }
                    }
                } catch (err) {
                    console.error("Error handling WebSocket message:", err);
                }
            })();
        });
    }, [userId]);

    const onSelectSection = (section, option = null) => {
        setSelectedSection(section);
        setSelectedOption(option);
    };

    const renderMain = () => {
        switch (selectedSection) {
            case "Overview":
                return (
                    <OverviewContent
                        onSelectSection={onSelectSection}
                        imagesAndVideosUrls={imagesAndVideosUrls}
                        setImagesAndVideosUrls={setImagesAndVideosUrls}
                        userId={user.userId}
                        roomId={roomId}
                        interactionItems={interactionItems}
                        roomType={roomType}
                    />
                );
            case "Media Frames":
                return (
                    <MediaFrames
                        selected={selectedOption}
                        setSelectedSection={setSelectedSection}
                        onSelectOption={(opt) => setSelectedOption(opt)}
                        imagesAndVideosUrls={imagesAndVideosUrls}
                        setImagesAndVideosUrls={setImagesAndVideosUrls}
                        token={user.token}
                        roomId={roomId}
                        userId={user.userId}
                        isSocketRequest={isSocketRequest}
                        setIsSocketRequest={setIsSocketRequest}
                    />
                );
            case "Interactions":
                return (
                    <Interactions
                        selected={selectedOption}
                        setSelectedSection={setSelectedSection}
                        onSelectOption={(opt) => setSelectedOption(opt)}
                        interactionItems={interactionItems}
                        roomType={roomType}
                        roomId={roomId}
                    />
                );
            case "Guestbook":
                return (
                    <Guestbook
                        selected={selectedOption}
                        setSelectedSection={setSelectedSection}
                        onSelectOption={(opt) => setSelectedOption(opt)}
                        user={user}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            <AppShell>
                {!loading && (
                    <>
                        <SidebarContainer>
                            <SidebarScroll>
                                <div style={{ marginBottom: 10 }}>
                                    <SidebarOption
                                        selected={selectedSection === "Overview"}
                                        onClick={() => onSelectSection("Overview", null)}
                                        isLabel
                                    >
                                        Overview
                                    </SidebarOption>
                                </div>

                                <ThinHr />

                                <SidebarSection
                                    title="Media Frames"
                                    collapsed={!mediaOpen}
                                    toggle={() => setMediaOpen((s) => !s)}
                                >
                                    <SidebarOption
                                        selected={
                                            selectedSection === "Media Frames" && selectedOption === "intraportPreview"
                                        }
                                        onClick={() => onSelectSection("Media Frames", "intraportPreview")}
                                    >
                                        Intraport Preview
                                    </SidebarOption>
                                    <SidebarOption
                                        selected={
                                            selectedSection === "Media Frames" && selectedOption === "squareImageFrame"
                                        }
                                        onClick={() => onSelectSection("Media Frames", "squareImageFrame")}
                                    >
                                        Square Image Frame
                                    </SidebarOption>
                                    <SidebarOption
                                        selected={
                                            selectedSection === "Media Frames" &&
                                            selectedOption === "verticalImageFrame1"
                                        }
                                        onClick={() => onSelectSection("Media Frames", "verticalImageFrame1")}
                                    >
                                        Vertical Image Frame 1
                                    </SidebarOption>
                                    <SidebarOption
                                        selected={
                                            selectedSection === "Media Frames" &&
                                            selectedOption === "verticalImageFrame2"
                                        }
                                        onClick={() => onSelectSection("Media Frames", "verticalImageFrame2")}
                                    >
                                        Vertical Image Frame 2
                                    </SidebarOption>
                                    <SidebarOption
                                        selected={selectedSection === "Media Frames" && selectedOption === "videoFrame"}
                                        onClick={() => onSelectSection("Media Frames", "videoFrame")}
                                    >
                                        Video Frame
                                    </SidebarOption>
                                </SidebarSection>

                                <ThinHr />

                                <SidebarSection
                                    title="Interactions"
                                    collapsed={!interOpen}
                                    toggle={() => setInterOpen((s) => !s)}
                                >
                                    {interactionItems.map((item) => (
                                        <SidebarOption
                                            key={item.name}
                                            selected={
                                                selectedSection === "Interactions" && selectedOption === item.name
                                            }
                                            onClick={() => onSelectSection("Interactions", item.name)}
                                        >
                                            {item.name}
                                        </SidebarOption>
                                    ))}
                                </SidebarSection>

                                <ThinHr />

                                <SidebarSection
                                    title="Guestbook"
                                    selected={selectedSection === "Guestbook"}
                                    onClick={() => onSelectSection("Guestbook")}
                                >
                                    {""}
                                </SidebarSection>
                            </SidebarScroll>
                        </SidebarContainer>
                    </>
                )}

                {loading && (
                    <LoadingIconContainer>
                        {" "}
                        <LoadingIcon />
                    </LoadingIconContainer>
                )}

                {!loading && <ContentArea>{renderMain()}</ContentArea>}

                {!loading && isSocketRequest && (
                    <>
                        <MediaFrames
                            selected={selectedOption}
                            setSelectedSection={setSelectedSection}
                            onSelectOption={(opt) => setSelectedOption(opt)}
                            imagesAndVideosUrls={imagesAndVideosUrls}
                            setImagesAndVideosUrls={setImagesAndVideosUrls}
                            token={user.token}
                            roomId={roomId}
                            userId={user.userId}
                            isSocketRequest={isSocketRequest}
                            setIsSocketRequest={setIsSocketRequest}
                        />
                    </>
                )}
            </AppShell>
        </>
    );
}
const LoadingIconContainer = styled.div`
    margin-top: 100px;
    display: flex;
    justify-content: center;
    width: 100%;
`;
